import React from 'react';
import { SubGroupWrapperProps } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper/types';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { useStyles } from './styles';

export const SubGroupWrapper: React.FC<SubGroupWrapperProps> = ({
  children, name, onTrash, rocketState, onRocket, customStyles, customOffsetStyles, onDrag = true,
}) => {
  const styles = useStyles();
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.subGroupContainer}>
          <div className={`${styles.subGroupWrapper} ${customStyles}`}>
            <div className={styles.wrapper}>
              <div className={styles.nameWrapper}>
                <div className={styles.name}>{ name }</div>
              </div>
              <div className={styles.actionsWrapper}>
                <GroupWrapperFiltersAction
                  onTrash={onTrash}
                  onDrag={onDrag ? () => {} : undefined}
                  rocketState={rocketState}
                  onRocket={onRocket}
                />
              </div>
            </div>
          </div>
          <div className={styles.body}>
            { children }
          </div>
        </div>
        <div className={`${styles.offset} ${customOffsetStyles}`} />
      </div>
    </div>
  );
};
